import request from '@/utils/request'

// 查询标书列表
export function listBid(query) {
  return request({
    url: '/screen/biddingdocument/bid/list',
    method: 'get',
    params: query
  })
}

// 查询标书详细
export function getBid(pid) {
  return request({
    url: '/screen/biddingdocument/bid/detail/' + pid,
    method: 'get'
  })
}

// 新增标书
export function addBid(data) {
  return request({
    url: '/screen/biddingdocument/bid/add',
    method: 'post',
    data: data
  })
}

// 修改标书
export function updateBid(data) {
  return request({
    url: '/screen/biddingdocument/bid/edit',
    method: 'post',
    data: data
  })
}

// 删除标书
export function delBid(pid) {
  return request({
    url: '/screen/biddingdocument/bid/delete/' + pid,
    method: 'get'
  })
}
